import { FaExclamationTriangle } from "react-icons/fa";
import { IoMdAlert } from "react-icons/io";

export function getPriorityText(priority) {
	if (priority === "high" || priority.toLowerCase().includes("ross")) return "ALTA";
	if (priority === "medium" || priority.toLowerCase().includes("arancio")) return "MEDIA";
	return "BASSA";
}

export const getBackgroundColor = (category, priority) => {
	if (category?.toLowerCase().includes("rosso")) return "bg-red-200 border-red-400";
	if (category?.toLowerCase().includes("arancione")) return "bg-orange-200 border-orange-400";
	if (category?.toLowerCase().includes("giallo")) return "bg-yellow-200 border-yellow-400";

	if (!priority) return <IoMdAlert className="text-black" />;

	if (priority === "high" || priority.toLowerCase().includes("ross"))
		return "bg-red-200 border-red-400";
	if (priority === "medium" || priority.toLowerCase().includes("arancio"))
		return "bg-orange-200 border-orange-400";
	if (priority === "low" || priority.toLowerCase().includes("giall"))
		return "bg-yellow-200 border-yellow-400";

	return "bg-gray-100 border-gray-400";
};

export const getLevelIcon = (priority) => {
	if (!priority) return <IoMdAlert className="text-black" />;
	if (priority === "high" || priority.toLowerCase().includes("ross"))
		return <FaExclamationTriangle className="text-red-600" />;
	if (priority === "medium" || priority.toLowerCase().includes("arancio"))
		return <IoMdAlert className="text-orange-700" />;
	if (priority === "low" || priority.toLowerCase().includes("giall"))
		return <IoMdAlert className="text-blue-600" />;
	return <IoMdAlert className="text-black" />;
};
